import { render, staticRenderFns } from "./ModalFreezeStatusAccount.vue?vue&type=template&id=05e0de9a&"
import script from "./ModalFreezeStatusAccount.vue?vue&type=script&lang=js&"
export * from "./ModalFreezeStatusAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports